import React, {FC, memo, useCallback, useEffect, useState} from "react";
import {ButtonGroup, FormInput, InputGroup} from "../../page/auth/login/LoginStyle";
import {Button, Form} from "react-bootstrap";
import {config} from "../../config";
import {IToken} from "../../store/sliceToken";
import {fetchToken, ITokenRequest} from "../../fetch/AuthRequest";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch, IRootState} from "../../store/configureStore";
import {actions} from "../../store/sliceModal";
import {isMobile} from "../../utils/Util";


export interface IFormCode {
    token: IToken,
    rollback: () => void

}

const FormCode: FC<IFormCode> = (props) => {
    const {token, rollback} = props

   // const token: IToken = useSelector((state: IRootState) => state.token)

    const nav = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    const [secondsRemaining, setSecondsRemaining] = useState(config.timer);
    const [inputCode, setInputCode] = useState(false)
    const [digit, setDigit] = useState(Array<string>(5));

    const handleFocus = (e: any, num: number) => {
        const massive = digit;
        if (e.target.value.length > 1) {
            e.target.value = e.target.value.substring(1, 2);
        }
        massive[num] = e.target.value;
        setDigit(massive)
        if (e.target.nextSibling) {
            e.target.nextSibling.focus();
        }
    }

    const handleFocusLast = (e: any) => {
        const massive = digit;
        if (e.target.value.length > 1) {
            e.target.value = e.target.value.substring(1, 2);
        }
        massive[digit.length] = e.target.value;
        setDigit(massive)
        if (digit.join('').length == 6) {
            submitCodeHandler(e)
        }
    }


    const submitCodeHandler = useCallback((event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault()
        event.stopPropagation()
        fetchToken({
            grant_type: 'verification',
            token: token.verification,
            verification_code: digit.join('')
        } as ITokenRequest).then(response => {
            if (response.status === 200) {
                nav(`${config.uiStart}/`);
            } else {
                dispatch(actions.showError(response.data))
            }
        })
    }, [digit, token])

    useEffect(() => {
        if (secondsRemaining > 0) {
            const timerId = setInterval(() => {
                setSecondsRemaining(prev => prev - 1);
            }, 1000);
            return () => clearInterval(timerId);
        }
        if (secondsRemaining <= 0) {
            setInputCode(false);
            rollback()
            setSecondsRemaining(config.timer);
        }
    }, [secondsRemaining, inputCode]);

    const onKeyDown = useCallback((e: React.KeyboardEvent<HTMLFormElement>) => {
        if (e.key === 'Enter') {
            submitCodeHandler(e)
        }
    }, [digit, token])

    return (
        <Form onSubmit={submitCodeHandler} onKeyDown={onKeyDown}>
            <p style={{marginBottom: "20px"}}>
                Введите код из сообщения
            </p>
            <InputGroup>
                <FormInput type={isMobile ? "number": "text"} onChange={(e) => handleFocus(e, 0)}
                />
                <FormInput type={isMobile ? "number": "text"} onChange={(e) => handleFocus(e, 1)}
                />
                <FormInput type={isMobile ? "number": "text"} onChange={(e) => handleFocus(e, 2)}
                />
                <FormInput type={isMobile ? "number": "text"} onChange={(e) => handleFocus(e, 3)}
                />
                <FormInput type={isMobile ? "number": "text"} onChange={(e) => handleFocus(e, 4)}
                />
                <FormInput type={isMobile ? "number": "text"} onChange={handleFocusLast}
                />
            </InputGroup>
            <p>
                осталось {secondsRemaining} секунд
            </p>
            <ButtonGroup>
                <Button variant="outline-primary" type={"submit"}>Войти</Button>
            </ButtonGroup>
        </Form>
)

}
export default memo(FormCode);
